import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from '../i18n';

export default function LanguageSelector() {
  const { lang, changeLang, LANGUAGES } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find((l) => l.code === lang);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className="relative" data-testid="language-selector">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg hover:bg-white/10 transition-colors text-sm"
        data-testid="language-selector-btn"
      >
        <span className="text-base leading-none whitespace-nowrap">{current?.flag}</span>
        <span className="hidden sm:inline text-white/70 uppercase text-xs font-medium tracking-wider">{lang}</span>
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-2 bg-[#1a1d23] border border-white/10 rounded-xl shadow-2xl overflow-hidden z-50 min-w-[160px]">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => { changeLang(l.code); setOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-3 text-sm transition-colors hover:bg-white/10 ${
                l.code === lang ? 'bg-white/5 text-white' : 'text-white/60'
              }`}
              data-testid={`lang-option-${l.code}`}
            >
              <span className="text-base whitespace-nowrap">{l.flag}</span>
              <span>{l.label}</span>
              {l.code === lang && <span className="ml-auto text-[var(--brand-cyan)] text-xs">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
